/** MQTT topic first-path segment used for all OTA publishes in this dashboard. */

/** Topic prefixes match firmware WATTSWAP_MQTT_ENV: dev | prod | staging */
export const MQTT_ENV_OPTIONS = [
    { value: 'prod', label: 'Prod' },
    { value: 'staging', label: 'Stage' },
    { value: 'dev', label: 'Dev' },
];

export const MQTT_ENV_STORAGE_KEY = 'firmware_manager_mqtt_env';
export const DEFAULT_MQTT_ENV = 'prod';

export function normalizeMqttEnv(raw) {
    const v = String(raw || '')
        .trim()
        .toLowerCase();
    if (v === 'prod' || v === 'production') return 'prod';
    // UI may say "Stage"; protocol / platformio use "staging"
    if (v === 'stage' || v === 'staging') return 'staging';
    if (v === 'dev' || v === 'development') return 'dev';
    return DEFAULT_MQTT_ENV;
}

export function readStoredMqttEnv() {
    try {
        return normalizeMqttEnv(localStorage.getItem(MQTT_ENV_STORAGE_KEY));
    } catch {
        return DEFAULT_MQTT_ENV;
    }
}

export function writeStoredMqttEnv(env) {
    const next = normalizeMqttEnv(env);
    try {
        localStorage.setItem(MQTT_ENV_STORAGE_KEY, next);
    } catch {
        /* ignore quota / private mode */
    }
    return next;
}
